export const MANUAL_ASSISTANT_QUERY_REQUEST = 'MANUAL_ASSISTANT_QUERY_REQUEST';
export const MANUAL_ASSISTANT_QUERY_SUCCESS = 'MANUAL_ASSISTANT_QUERY_SUCCESS';
export const MANUAL_ASSISTANT_QUERY_FAILURE = 'MANUAL_ASSISTANT_QUERY_FAILURE';
